__webpack_require__.p = "https://static.nrk.no/dh/module/bildesveip/static/";